import AddressForm from '@/common/components/AddressForm'
import useAddressForm from '@/common/hooks/useAddressForm';
import { AddressData } from '@/common/types/address'
import { RequestedReview } from '@/features/establishmentLeadsFunnel/components/RequestedReview'
import { ReviewButtons } from '@/features/establishmentLeadsFunnel/components/ReviewButtons'
import { PublicCompanyLeadsFunnelUpdateValidationSchema } from '@/features/publicCompanyLeadsFunnel/schemas/update.schema'
import { LastReview } from '@/features/publicCompanyLeadsFunnel/types/publicCompanyLead'
import { UseMutateFunction } from '@tanstack/react-query'

interface AddressSectionProps {
  address?: AddressData & { last_review: LastReview }
  submit?: () => void
  approveAddressLead?: UseMutateFunction<void, Error, { description?: string } | undefined, unknown>
  declineAddressLead?: UseMutateFunction<void, Error, { description?: string } | undefined, unknown>
  disabled?: boolean
}

export const AddressSection = ({
  address,
  submit,
  approveAddressLead,
  declineAddressLead,
  disabled,
}: AddressSectionProps) => {
  const addressForm = useAddressForm<PublicCompanyLeadsFunnelUpdateValidationSchema>({
    path: 'address_attributes',
    initialAddress: address as AddressData || {},
    disabled,
    onAddressChange: (_, isValid) => {
      if (!disabled && isValid) {
        submit?.();
      }
    }
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between">
        <p className="text-[18px] font-bold">Endereço</p>
        {approveAddressLead && declineAddressLead && (
          <ReviewButtons
            reviewState={address?.last_review?.state}
            onApprove={approveAddressLead}
            onDecline={declineAddressLead}
          />
        )}
      </div>
      {address?.last_review?.state === 'disapproved' && (
        <RequestedReview description={address?.last_review?.description} />
      )}

      <AddressForm
        addressForm={addressForm}
        disableFields={disabled}
        markFieldsAsRequired
      />
    </div>
  )
}
